module.exports = "<h1>Activate Campaign</h1>\n"